import React, { useEffect, useRef } from 'react';
import Styled from 'styled-components';
import { TextLink } from '@vds/buttons';

import {
  viewport,
  isEUPFlow,
  isComboFlow,
  isExternalFlow,
  isCPCCheckAvailabilityFlow,
  isRetailFlow,
  isGlobalHeader,
  isExpressCheckout,
  isDesktopResolutionViewPort,
  isTablet,
  GetCurrentPageName,
  isMobile,
  isMVA,
  // isExpressCheckout,
} from './Helpers/index';
import { Body } from './Typography/index';
import { mvaLinkApiCall } from './MVAApiCall';
import { apiUrls } from '../../constants/apiUrl';

const StyledFooter = Styled.footer(() => ({
  background: 'white',
  cursor: 'pointer', 
  textDecoration: 'none',
  flex: '0 1 auto',
  marginTop: (viewport() === 'tablet' && isEUPFlow() === 'true') || (isDesktopResolutionViewPort() && isExpressCheckout()) 
    ? '0px' 
    : '30px',
  position: 'relative',
  left: 0,
  bottom: 0,
  maxWidth: '1272px',
  marginLeft: 'auto',
  marginRight: 'auto',
  '@media (max-width: 1025px)': {
    paddingLeft: '16px', 
    paddingRight: '16px',
  },
}));

const FooterContent = Styled.div`
    padding:8px 0 8px 4px;
`;

const PageFooter = () => {
  const expressFooterContainer = useRef(null);

  useEffect(() => {
    if (isExpressCheckout() && isMVA()) {
      // Initialize the position on load
      adjustPolicyLinkPosition();

      // Add resize event listener
      window.addEventListener('resize', adjustPolicyLinkPosition);

      // Add onload event listener
      window.addEventListener('onload', adjustPolicyLinkPosition);

      // Add orientationchage event listener
      window.addEventListener('orientationchage', adjustPolicyLinkPosition);

      return () => {
        // Clean up the event listener on unmount
        window.removeEventListener('resize', adjustPolicyLinkPosition);
        window.removeEventListener('onload', adjustPolicyLinkPosition);
        window.removeEventListener('orientationchage', adjustPolicyLinkPosition);
      };
    }
  }, [isExpressCheckout(), isMVA()]);

  const adjustPolicyLinkPosition = () => {
    setTimeout(() => {
      const contentHeight = document.querySelector('.expressContainer')?.offsetHeight;
      const windowHeight = window?.innerHeight;
      const spaceHeight = windowHeight - contentHeight;
      const minHeight = window?.innerWidth > 1024 ? 250 : 100;
      if (contentHeight && expressFooterContainer.current) {
        if (spaceHeight < minHeight) {
          expressFooterContainer.current.style.position = 'unset';
          expressFooterContainer.current.style.marginLeft = '0';
          expressFooterContainer.current.style.right = 'unset';
        } else {
          expressFooterContainer.current.style.position = 'absolute';
          expressFooterContainer.current.style.marginLeft = '20px';
          expressFooterContainer.current.style.right = '0';
        }
      }
    }, 3000);
  };

  const isHidePrivacyPolicy =
    isComboFlow() ||
    isExternalFlow() ||
    isCPCCheckAvailabilityFlow() ||
    isRetailFlow() ||
    isGlobalHeader() ||
    window.location.href.indexOf('DeviceUpgrade') > -1 ||
    window.location.href.indexOf('WestworldUpgrade') > -1;

  if (isHidePrivacyPolicy) {
    return (
      <div
        style={{
          marginBottom: isExpressCheckout() && !isDesktopResolutionViewPort() ? '100px' : 0,
        }}
      />
    );
  }

  const onClickPrivacyPolicyLink = () => {
    if (isMVA()) {
      mvaLinkApiCall(apiUrls().privacyPolicyURL);
    } else {
      window.open(apiUrls().privacyPolicyURL, '_blank');
    }
  };
   const getMarginTopValue = () => {
    let value = '20px';
    if (isExpressCheckout() && !isDesktopResolutionViewPort()) {
      value = isMVA() ? '64px' : '16px';
    }
    return value;
  }
   const getPaddingValue = () => {
    let value = '';
    if (isExpressCheckout()) {
      value = (isDesktopResolutionViewPort() && GetCurrentPageName() === 'expresstos.html') ? '8px 24px 8px 0px' : 0;
    }
    return value;
  }

  const getMarginValue = () => {
    let value = 0;
    if (isExpressCheckout()) {
      value = !isDesktopResolutionViewPort() ? '100px' : '32px';
    }
    return value;
  }
  /* adding margin-bottom not to hide this link below sticky footer section */
  return (
    <StyledFooter
      data-testId="footer-container"
      ref={expressFooterContainer}
      className={isExpressCheckout() && !isTablet() && !isMobile() && GetCurrentPageName() === 'expresstos.html' ? 'tosFooter' : 'streamlineminicart'}
      style={{
        marginTop: getMarginTopValue(),
        marginBottom: (isExpressCheckout() && !isDesktopResolutionViewPort()) || GetCurrentPageName() === 'streamlineordering.html' || GetCurrentPageName() === 'addons.html' || GetCurrentPageName() === 'progressiveplan.html' ? '100px' : '0px',
      }}
    >
      <FooterContent
        style={{
          padding: getPaddingValue(),
          marginBottom: getMarginValue(),
        }}
      >
        <Body color={isExpressCheckout() ? '#0077B4' : '#025E8D'} size="small">
          <TextLink
            aria-label="Privacy Policy opens in a new tab"
            onClick={(e) => {
              e.preventDefault();
              onClickPrivacyPolicyLink();
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onClickPrivacyPolicyLink();
              }
            }}
          >
            Privacy Policy
          </TextLink>
        </Body>
      </FooterContent>
    </StyledFooter>
  );
};

export default PageFooter;
